export const mediaBreakpoints = {
  XS: '360px',
  SM: '600px',
  MD: '1200px',
  LG: '1600px',
};

export const breakpoints = [
  '0px',
  mediaBreakpoints.XS,
  mediaBreakpoints.SM,
  mediaBreakpoints.MD,
  mediaBreakpoints.LG,
];
